import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ServiceResponse } from '@common/data-models/service/service-response';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WastebinService {
    nomWebServicesJson = inject(NomWebServicesJson);

    public patchWastebinContentObservable(args: { database: string; path: string; guid: string }): Observable<ServiceResponse<boolean>> {
        return this.nomWebServicesJson
            .patchObservable(
                `/api/Wastebin`,
                {
                    database: args?.database,
                    path: args?.path,
                    guid: args?.guid,
                },
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                        'X-ENPS-TOKEN': this.nomWebServicesJson.nomTokenId,
                    }),
                    responseType: 'json',
                    observe: 'response',
                }
            )
            .pipe(
                map(() => {
                    return new ServiceResponse<boolean>(true, true);
                }),
                catchError((error: HttpErrorResponse) => {
                    this.nomWebServicesJson.showErrorModal({
                        message: 'Unable to restore content',
                        detailMessage: `Unable to restore content. \r\nStackTrace: WastebinService.getWastebinContentObservable(); \r\nError: ${error.message}`,
                    });
                    return of(new ServiceResponse<boolean>(false, `Unable to restore content ${error.message}`));
                })
            );
    }
}
